module.exports = __webpack_public_path__ + "img/microchip.ca319047.svg";